(() => {
  const g = window;
  if (g.GlossaryCore) return;

  const parseTags = (raw) => {
    if (!raw) return [];
    try {
      const j = JSON.parse(raw);
      if (Array.isArray(j)) return j.map(t => String(t).toLowerCase().trim()).filter(Boolean);
    } catch (e) {}
    return String(raw).split(',').map(t => t.toLowerCase().trim()).filter(Boolean);
  };

  const fieldsToMap = (fields) => Object.fromEntries((fields || []).map(f => [f.key, f]));

  // Build the field map from a metaobject node, folding in the separately
  // aliased image/collection reference selections. References are only
  // resolved for the two keys the grids actually use (image, related_collection);
  // resolving `reference` on every field can 500 the Storefront API when an
  // entry has a single article/product reference (e.g. invert related_blog_posts).
  const nodeToFieldMap = (node) => {
    const map = fieldsToMap(node && node.fields);
    if (node && node.imageReference) {
      map.image = Object.assign({}, map.image, node.imageReference);
    }
    if (node && node.collectionReference) {
      map.related_collection = Object.assign({}, map.related_collection, node.collectionReference);
    }
    return map;
  };

  const sfFetch = async ({ endpoint, token, query, variables }) => {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query, variables })
    });

    let json = null;
    try { json = await res.json(); } catch (e) {}

    if (!res.ok) {
      const msg = json?.errors?.[0]?.message || `HTTP ${res.status}`;
      throw new Error(msg);
    }

    if (json?.errors?.length) {
      throw new Error(json.errors[0].message || 'GraphQL error');
    }

    return json;
  };

  const METAOBJECTS_QUERY = `
    query ($type: String!, $first: Int!, $after: String) {
      metaobjects(type: $type, first: $first, after: $after) {
        edges {
          node {
            handle
            onlineStoreUrl
            fields {
              key
              value
            }
            imageReference: field(key: "image") {
              reference {
                __typename
                ... on MediaImage { image { url altText } }
              }
            }
            collectionReference: field(key: "related_collection") {
              reference {
                __typename
                ... on Collection { handle }
              }
            }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  g.GlossaryCore = {
    parseTags,
    fieldsToMap,
    nodeToFieldMap,
    sfFetch,
    METAOBJECTS_QUERY
  };
})();
